'use client';

import { PACK_HASH } from '@app-types/home-pack';

import { Breadcrumb as BreadcrumbComponent } from '@components/breadcrumb';

import { paths } from '@helpers/path';

import { PackConfigType } from '@home-pack/helpers';

export function Breadcrumb({ slug, config }: Readonly<{ slug: PACK_HASH; config: Record<string, PackConfigType> }>) {
    return (
        <BreadcrumbComponent
            elements={[
                {
                    name: 'home',
                    label: 'Accueil',
                    href: '/',
                },
                {
                    name: 'home FAI',
                    label: 'Offres internet',
                    href: paths.homeFai,
                },
                {
                    name: slug,
                    label: config[slug]?.descriptiveTitle || '',
                    href: `${paths.homePack}/${slug}`,
                },
            ]}
        />
    );
}
